import { Refresh } from "@material-ui/icons";
import { PrimaryIconButton } from "components";

const PrimaryRestoreButton = ({ onClick, tooltipTitle, disabled, loading, ...rest }) => {
  return (
    <PrimaryIconButton
      icon={<Refresh />}
      onClick={onClick}
      tooltipTitle={tooltipTitle}
      disabled={disabled}
      loading={loading}
      {...rest}
    />
  );
};

export default PrimaryRestoreButton;
